// routes/generator.image-stitching.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'

const getClientModule = () =>
  import('src/clientRoutes/generator.image-stitching')

export const handle = { name: 'generator/image-stitching' }

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
